<template>
  <div>
    <v-select hide-details :label="label" :items="items" item-text="Kod" item-value="Kod" v-model="Model">

    </v-select>
  </div>
</template>

<script>
  import tool from "../tools";
  import arksnackbar from "@/components/app/coper/comp/arksnackbar.vue";

  export default {
    props: ["value", "apiname", "getcode", "label", "tip", "required", "rules"],
    components: {
      arksnackbar
    },
    computed: {
      Model: {
        get: function () {

          var r = null

          if (this.value != undefined && this.value != null) {
            var r = {
              Kod: ""
            };
            r = {
              Kod: this.value
            };
          }

          return r;

        },
        set: function (newValue) {




          this.$emit("input", newValue);
        }
      },
    },

    data() {
      return {
        deneme: null,
        loading: false,
        items: [],
        search: null,
        status: tool.NewSatatus(),
        ayrac: "  -  "
      };
    },

    watch: {
      getcode: function (newVal, oldVal) {
        this.querySelections(newVal.kod);
      }
    },
    mounted() {

      if (this.value != null || (this.getcode != null && this.getcode != undefined)) {
        this.querySelections(this.getcode.kod);
      }

    },
    methods: {
      querySelections(v) {
        var prm = {
          SaticiKodu: v
        };
        setTimeout(() => {
          this.Ara(prm);
        }, 400);
      },

      IsimAra(v) {
        return (
          v.isim.replace(this.ayrac, "-") +
          this.ayrac +
          v.kod.replace(this.ayrac, "-")
        );
      },


      Ara(prm) {
        this.status.loading = true;
        this.items = []
        tool.http_post(this, 'RentACarAracTipi', prm).then(
          response => {
            this.items = response.body.data
          },
          response => {
            // this.status = tool.responseToStatus(response);
          }
        );
      }
    }
  };
</script>